export enum PaymentStatus {
  PENDING_PAYMENT = 'Asignado',
  PAID = 'Pagado',
  WITHOUT_PAYMENT = 'Sin asignar',
}
